module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "line_fm"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/05_ack"
    }
  }, [_vm._v("Acknowledgments vii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/07_intro"
    }
  }, [_c('b', [_vm._v("Introduction: We Become What We Measure")]), _vm._v(" 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_intro#con1"
    }
  }, [_vm._v("Casting a Spell 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_intro#con2"
    }
  }, [_vm._v("Exploring a Path 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch01"
    }
  }, [_c('b', [_vm._v("  1.  More, Better, Faster: The Beginnings")]), _vm._v(" 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch01#con3"
    }
  }, [_vm._v("Productivity, Growth, and Success 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch01#con4"
    }
  }, [_vm._v("Goals and Measures 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch01#con5"
    }
  }, [_vm._v("Values and Measures 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/09_ch02"
    }
  }, [_c('b', [_vm._v("  2.  The Origins of Bling: The Spirit of Economic Growth")]), _vm._v(" 40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_ch02#con6"
    }
  }, [_vm._v("The World of Growth: Refining the Measure 52")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_ch02#con7"
    }
  }, [_vm._v("Business Accounting Goes National 57")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/10_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  3.  The Crucible of Crisis: The Great Depression and the Need for Economic Indicators")]), _vm._v(" 65")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  4.  Born from Disaster: The Making of a Key Measure")]), _vm._v(" 83")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04#con8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Challenge 84")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04#con9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Players 89")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04#con10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Method 93")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04#con11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Findings 99")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04#con12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Conundrum: Translating Findings into Action 102")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  5.  Forged in War")]), _vm._v(" 107")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  6.  Global Domination: The Age of GDP")]), _vm._v(" 117")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#con13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Richer or Poorer 117")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#con14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stunted Priesthood 121")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#con15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stopgap Consensus 123")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/13_ch06#con16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going Global 128")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#con17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Rules 130")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#con18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GDP Junkies 133")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#con19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shackled in Fool’s Gold 139")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  7.  Today’s ABC of GDP")]), _vm._v(" 143")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch07#con20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s an Emperor, but Does It Have Clothes? 152")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch07#con21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why It Matters 157")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  8.  More Is Not Enough")]), _vm._v(" 160")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch08#con22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Little Big Number: Our Report Card for Success 174")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch08#con23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emerging Dissent 178")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("  9.  “The People of Plenty Are a People of Waste”")]), _vm._v(" 184")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch09#con24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Spell 204")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10.  From Alchemy to Reason: What If? A Thought Experiment")]), _vm._v(" 208")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch10#con25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mental Cobwebs 219")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch10#con26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One More Time: Simon Kuznets 230")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch10#con27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clearing a Path 236")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11.  Looking Forward")]), _vm._v(" 243")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch11#con28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Daring Vision 250")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch11#con29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Moment of Possibility 265")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/19_app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A. The Measure as Guide 271")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/20_note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes 277")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/21_bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography 351")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index 389")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19080aa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_toc.vue
// module id = 69
// module chunks = 0